import React from 'react';

import Icon from 'components/DesignSystem/Icon';
import { cssVar } from 'constants/theme';

import './index.scss';

export interface OptionRowProps {
  label: string;
  sublabel?: string;
  selected: boolean;
  onSelect: () => void;
}

export default function OptionRow({
  label, sublabel, selected, onSelect,
}: OptionRowProps) {
  return (
    <button
      type="button"
      className={`register-option-row${selected ? ' selected' : ''}`}
      onClick={onSelect}
    >
      <span className="register-option-row-text">
        <span className="register-option-row-label">{label}</span>
        {sublabel && <span className="register-option-row-sublabel">{sublabel}</span>}
      </span>
      {selected && <Icon iconType="checkmark" color={cssVar('text-accent')} />}
    </button>
  );
}
